export const sortedList = (list, option) => {
  if (option) {
    const index = list.findIndex((obj) => obj.label === option.label);

    if (index > -1) {
      list.splice(index, 1);
      list.unshift(option);
    }
  }

  return list;
};

export const checkDateStringExist = (string) => {
  const pattern = /\b(?:date|Date)\b/;

  return pattern.test(string);
};
